import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { updateCellsHeight } from 'containers/ArtboardPreview/actions';

export const useUpdateCellHeight = (
  relationId: string,
  element: HTMLDivElement | undefined | null,
  extraHeight = 0,
): void => {
  const dispatch = useDispatch();
  const extraHeightRef = useRef(extraHeight);

  useEffect(
    () => {
      if (!element) {
        return;
      }
      const updateCellHeight = (height: number): void => {
        dispatch(updateCellsHeight(relationId, height - extraHeightRef.current));
      };
      updateCellHeight(element.offsetHeight);

      const resizeObserver = new ResizeObserver((entries) => {
        const newHeight = entries[0].contentBoxSize[0].blockSize;
        requestAnimationFrame(() => updateCellHeight(newHeight));
      });
      resizeObserver.observe(element);

      return () => resizeObserver.disconnect();
    },
    [relationId, element, dispatch],
  );
};
